import { combineReducers } from 'redux';

import file from './file';

export default combineReducers({
  file,
});
